import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getCreatePinCodePath = () => urlHelper('/auth/create-pin-code');
